Vue.component('quote-fields', {
    props: ['fields'],

    data () {
        return {
            quoteFields: [],
        };
    },

    mounted () {
        this.quoteFields = this.fields ? this.fields : [];
    },

    methods: {
        addField () {
            this.quoteFields.push({
                type: '',
                value: '',
            });
        },

        removeField (index) {
            this.quoteFields.splice(index, 1);
        },
    },
});